import { useSelector } from 'react-redux';

import {
    getOtherRecordingParticipants,
    isOtherUserBroadcasting,
    selectHasNonSelfParticipantRaisedHand,
    selectShouldShowNewWaitingRoomPeersIndicator,
} from '../../../selectors';
import { selectIsCloudRecordingRunning } from '../../cloud-recording';

interface UseDotColorParams {
    showDots?: boolean;
    hasOtherSharing?: boolean;
}

export const useDotColor = (params: UseDotColorParams = {}): Maybe<'green' | 'red'> => {
    const { showDots, hasOtherSharing } = { showDots: true, hasOtherSharing: false, ...params };
    const otherRecordingParticipants = useSelector(getOtherRecordingParticipants);
    const hasOtherBroadcasting = useSelector(isOtherUserBroadcasting);
    const hasNewWaitingRoomPeers = useSelector(selectShouldShowNewWaitingRoomPeersIndicator);
    const hasRaisedHand = useSelector(selectHasNonSelfParticipantRaisedHand);
    const isCloudRecordingRunning = useSelector(selectIsCloudRecordingRunning);

    if (!showDots) {
        return;
    }

    const shouldShowGreenDot =
        hasOtherBroadcasting || hasNewWaitingRoomPeers || hasRaisedHand || hasOtherSharing || isCloudRecordingRunning;

    if (shouldShowGreenDot) {
        return 'green';
    }

    const hasOtherRecording = otherRecordingParticipants.length > 0;
    const shouldShowRedDot = hasOtherRecording && !hasOtherBroadcasting;

    if (shouldShowRedDot) {
        return 'red';
    }
};
